import React, { Component } from "react";
import FoodWrapperAdmin from "./FoodWrapperAdmin";
import { delete_category, put_category, delete_food, delete_image, delete_allergen } from '../api/UserFunctions';
import { changeCategories, changeFoods, changeCount } from "../actions/index";
import { connect } from "react-redux";
import Slider from "react-slick";
import Loading from './Loading';

const mapStateToProps = state => {
	return { categories: state.categories, foods: state.foods, allergens: state.allergens, images: state.images, count: state.count};
  }; 

  function mapDispatchToProps(dispatch) {
    return {
      changeCategories:categories => dispatch(changeCategories(categories)),
      changeFoods:foods => dispatch(changeFoods(foods)),
      changeCount:count => dispatch(changeCount(count))
    };
}

class CategoryWrapperAdmin extends Component {

    constructor(props){
        super(props);
        this.state = {
            name:this.props.name,
            selectedFile: null,
            foods_change:[],
            index:0,
            selectSort:1
            
        };

        this.onChange = this.onChange.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleModify = this.handleModify.bind(this);
        this.handleBefore = this.handleBefore.bind(this);
        this.rerenderParentCallback = this.rerenderParentCallback.bind(this);

    }

    handleBefore(event) {
        event.preventDefault();
        const r = window.confirm("Ëtes-vous vraiment sûr de vouloir supprimer la catégorie "+this.props.name+" ?"); 
        if(r == true)
        { this.handleDelete(event); }
        else{
            console.log("non");
        }
      }


      rerenderParentCallback() {
		this.forceUpdate();
	  }

    onChange(e) {
        this.setState({ [e.target.name]: e.target.value })
      }
    
    onFileChange = event => { 
        // Update the state     
        this.setState({ selectedFile: event.target.files[0] });
    }; 

    handleDelete(event) {
        event.preventDefault();
        if(typeof(this.props.categories[0]) !== "undefined"){
			if(this.props.categories.length > 1){
				delete_category(this.props.id).then(res => {
                    var big = [];
				  
				this.props.count.forEach((counter,index) => {			
					var keys = Object.keys(counter);		
					if(this.props.id === parseInt(keys[0])){
						//big = [];
					}
					else{
						big.push(counter);
					}
				  
				  });
		            this.props.changeCount(big);
                    
				  
					if(typeof(this.props.categories[0]) !== "undefined"){
						var total = []
                        var counting = 0;
                        var patch = false;
						this.props.categories.forEach((category,index) => {
                            
						  if(category["id"] !== this.props.id){
                            counting++;
                            var new1={
                                id:category.id,
                                name:category.name,
                                sortList:counting
                              }	
							  total.push(new1)
                              if(patch){
                                put_category(new1).then(res => {});
                                
                              }
						  }else{
                            patch = true;
                          }
						
						});
                        total.sort((a, b) => a.sortList - b.sortList);
						this.props.changeCategories(total);
						}
				  });

                  this.props.foods.forEach((food,index) => {
							
                    if(food["id_category"] === this.props.id){
                        delete_food(food["id"]).then(res => {
                        });
                        this.props.allergens.forEach((allergen,index) => {
							
                            if(allergen["id_food"] === food["id"]){
                                delete_allergen(allergen["id"]).then(res => {
                                });
                            }
                          
                          });

                          this.props.images.forEach((image,index) => {
							
                            if(image["id_food"] === food["id"]){
                                delete_image(image["id"]).then(res => {
                                });
                            }
                          
                          });
                    }
                  
                  });

                  this.setState({index:this.state.index+1});
			
			}
			}
        
    }

    componentDidMount(){
        this.props.popupParentCallback({display:"none"},"", "");
        this.props.categories.forEach((category,index) => {
            if(category.name.localeCompare(this.props.name)===0){
                this.setState({selectSort:category.sortList});
            }
        });
    }
    handleModify(event) {
        event.preventDefault();
        if(this.state.name.localeCompare("") !== 0){
            var _category = {
                id:this.props.id,
                name:this.state.name,
                sortList:this.state.selectSort
            }
            put_category(_category).then(res => {
                      
                if(typeof(this.props.categories[0]) !== "undefined"){
                    var total = [];
                    this.props.categories.forEach((category,index) => {
                            var new1={
                                id:category.id,
                                name:category.name,
                                sortList:category.sortList
                              }	
                              console.log("modify1 "+this.state.selectSort+" "+this.props.selectSort);
                              if(parseInt(this.state.selectSort) !== parseInt(this.props.selectSort)){
                                console.log("modify2 "+this.state.selectSort+" "+category.sortList );
                                  if(parseInt(category.sortList) === parseInt(this.state.selectSort)){
                                    var new2={
                                        id:category.id,
                                        name:category.name,
                                        sortList:this.props.selectSort
                                      }	
                                      console.log("modify3 "+JSON.stringify(new2) );
                                      total.push(new2)
                                      put_category(new2).then(res => {});
                                  }
                                  else if(category["id"] !== this.props.id){
                                    total.push(new1)
                                }
                                else{
                                  total.push(_category)
                                }
                              }
                              else{
                                if(category["id"] !== this.props.id){
                                    total.push(new1)
                                }
                                else{
                                  total.push(_category)
                                }
                              }      
                      
                    
                    });
                    total.sort((a, b) => a.sortList - b.sortList);
                    this.props.changeCategories(total);
                    }
              });
        }
        
        
    }

    componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
          this.setState({ name: this.props.name });
        }

        if (this.props.selectSort !== prevProps.selectSort) {
            this.setState({ selectSort: this.props.selectSort });
          }
          if (this.props.categories !== prevProps.categories) {
            this.props.categories.forEach((category,index) => {
                if(category.name.localeCompare(this.props.name)===0){
                    if(parseInt(this.state.selectSort) !== category.sortList){
                        this.setState({selectSort:category.sortList});
                    }
                   
                }
            });
          }
        
          
       
      }

      renderSort(){
		
        return this.props.categories.map((category,index) => {  
            return (
                    <option key={index} value={category.sortList}>{category.sortList}</option>
            ) 
        });  
        }

    render() {
        if(typeof(this.props.count[0])!=="undefined"){
            var counter = 0;
            this.props.count.forEach((count, index) => (
                typeof(count[this.props.id.toString()])!=="undefined"?counter=count[this.props.id.toString()]:null
            ));
            
            var settings =
            {
                dots: true,
                infinite: false,
                arrows : true,
                rows: 1,
                speed: 400,
                slidesToShow: counter,
                slidesToScroll: 1,        
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: (counter<3)?counter:3,
                        }
                    },
                    {
                        breakpoint: 1000,
                        settings: {
                            slidesToShow: (counter<2)?counter:2,
                        }
                    },
                    {
                        breakpoint: 700,
    
                        settings: {
                            centerMode :(counter==1)?false:true,
                            centerPadding: '5px',
                            slidesToShow: 1,
                        }
                    }
                ]
            }
            console.log("counter "+counter+" name "+this.props.name+ " id "+this.props.id.toString()+ " settings "+JSON.stringify(settings));
            var total = this.props.foods;
            total.sort((a, b) => a.sortList - b.sortList);

            return (
                <div>
                    <form id="entrees" className="food-category">
                        <div class="header">
                            <input type="text" value="ID" class="invisible"/>	
                            <select name="selectSort" value={this.state.selectSort}  onChange={this.onChange}>
                                            {this.renderSort()}
                            </select>
                            <input type="text" name="name" onChange={this.onChange} value={this.state.name}/>
                            
                            <div id={this.props.name}></div>
                            <div className="commands">
                                <label class="command delete" onClick={(event) => this.handleBefore(event)}>
                                        <input type="submit"    value="Supprimer" class="invisible"/>
                                        <div>X</div>
                                    </label>
                                <label class="command edit">
                                    <input type="submit" onClick={(event) => this.handleModify(event)} value="Editer" class="invisible"/>
                                    <div>&#10003;</div>
                                </label>
                        </div>
                        </div>                    
                    </form>
                    {counter> 0 ? 
                        <Slider 
                            {...settings} 
                            className="food-wrapper">
                            {total.map((food, index) => (
                                this.props.id==food.id_category?<FoodWrapperAdmin rerenderParentCallback={this.rerenderParentCallback} popupParentCallback2={this.popupParentCallback2} popupParentCallback={this.props.popupParentCallback} data-index={index} key={index} test_image={this.props.test_image} category_id={this.props.id} id={food.id} category_name={this.props.name} food_name={food.name} price={food.price} description={food.description} is_active={food.is_active} is_emphased={food.is_emphased} all1={this.props.all1} all2={this.props.all2} all3={this.props.all3} all4={this.props.all4} all5={this.props.all5} all6={this.props.all6} all7={this.props.all7} all8={this.props.all8} selectSort={food.sortList}/>:null
                            ))}</Slider> 
                        : null }
                </div>
                
                
            );
        }
        return (      
            <div>
            <Loading/>      				
          </div>
          );
        
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(CategoryWrapperAdmin);


// WEBPACK FOOTER //
// ./src/components/CategoryWrapperAdmin.js